import { Button, Typography } from '@mui/material'
import React, { memo } from 'react'
import { MIN_ROWS_TO_VIRTUALIZE_TABLE } from '../TableField'
import { TABLE_ADD_ROW_TYPE } from '../../../../../utility/constants'

const TableFooter = ({ onAddRow, totalRows, disabled = false }) => {
  return (
    <div style={{ display: 'flex', columnGap: 16, margin: '10px 0px 5px' }}>
      <Button
        color="primary"
        variant="contained"
        sx={{ height: 26 }}
        onClick={() => onAddRow(TABLE_ADD_ROW_TYPE.ADD_ROW)}
        disabled={disabled}
      >
        Add Row
      </Button>
      <Button
        color="primary"
        variant="contained"
        sx={{ height: 26 }}
        onClick={() => onAddRow(TABLE_ADD_ROW_TYPE.COPY_ROW)}
        disabled={disabled}
      >
        Copy Row
      </Button>
      {totalRows >= MIN_ROWS_TO_VIRTUALIZE_TABLE && <Typography>{totalRows} rows!</Typography>}
    </div>
  )
}

export default memo(TableFooter)
